import React from "react";
import Form from "react-bootstrap/Form";
import { Constants } from "../../CommonMethhods/Constants";

function DropdownFilter(props) {
  return (
    <Form.Select size="lg" aria-label="Default select example">
      <option value="monthly">{Constants.Monthly}</option>
      <option value="quarterly">{Constants.Quarterly}</option>
      <option value="yearly">{Constants.Yearly}</option>
    </Form.Select>
  );
}

export default DropdownFilter;
